import { useDropzone } from "react-dropzone";
import { Label } from "lib";
import { Button, Modal } from "react-bootstrap";
import { useState, useEffect } from "react";
import ImageUploaded from "./../../assets/images/image_uploaded.svg";
import "./index.scss";
import ImageUpload from "../../assets/images/image_upload.svg";
import Image from "../Image";
import { useDispatch, useSelector } from "react-redux";
import Toast from "components/ToastComponent";
import { clearSelectedData, setbulkaddCustomer, clearbulkaddCustomer,setbulkaddWorkflow } from "redux/formDisplay";
import Papa from "papaparse";
import * as XLSX from 'xlsx';
import { setcsvBulkresponse } from "redux/dashboardReducer";
import { handleEmailBulkNotification } from "helper/callbacks";
import { createBulkPrimaryWorkFlows, ValidateCsvData } from "api/formDisplay";
import { uniqueWorkFlowId } from "helper/uniqueWorkFlowId";
import { createMasterDataPayload } from "helper/createPayload";
import { matchDetails } from "helper/calculateNetAsset";
import { validateDate } from "helper/validatedob";
import{createUserHierarchy, updateDropdownOptions} from "api/user"

const CsvUpload = (props) => {
    const {
        label,
        enum: enums,
        tooltip,
        name,
        add_customer,
        error,
        clearFieldError,
        remove_disabled,
        selectedData,
        size,
        isEditable,
        is_disabled,
        validators,
        maxSize,
        isDisabLed,
        setSelectedData,
        error_messages,
        bulk_upload,
        custom_styles,
        label_style,
        user_hierarchy
    } = props;

    let link = window.location.href;
    let splitUrl = link.split("/");
    splitUrl.splice(4, 1);
    link = splitUrl.join("/");
    const [uploadedFile, setUploadedFile] = useState(null);
    const [ErrorFields, setUniqueErrorFields] = useState([]);
    const [fileName, setFileName] = useState();
    const [fileSize, setFileSize] = useState();
    const [uploading, setUploading] = useState(false);

    const [messageToast, setMessageToast] = useState({ type: "", msg: "" });
    const handleClose = () => seterrModal(false);
    const [errModal, seterrModal] = useState(false);
    const organisationInfo = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo)
    const dispatch = useDispatch();
    const { dashboardConfig } = useSelector((state) => state.dashboardReducer);
    const maxSizeInMb = Math.ceil(maxSize / (1024 * 1024));
    const organisationIdOfUser = useSelector(
        (state) => state?.loggedInUserInfo?.userAuthInfo?.profileInfo?.organisationId
    );

    let pattern = validators?.email?.pattern;
    var regex_pattern = new RegExp(pattern);
    const workflowConfig = useSelector(
        (state) => state.configurationReducer.config
      );
      const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo)
      let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
      let loggedInUserName = loggedUserId ? (`${(loggedInUserInfo?.profileInfo?.first_name || "") + " " + (loggedInUserInfo?.profileInfo?.last_name || "")}`) : "";
      let loggedInUserEmail = loggedUserId && loggedInUserInfo?.profileInfo?.emailId
      let loggedInUserMobileNumber = loggedUserId && loggedInUserInfo?.profileInfo?.mobileNumber
      const staticData = useSelector((state) => state.staticData);
      const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        accept: {
            "text/csv": [".csv"],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
            // "application/pdf":[]
        },
        maxSize: maxSize,
        onDropAccepted: (acceptedFiles) => {
            clearFieldError && clearFieldError(name);
            acceptedFiles.forEach((file) => {
                setUploading(true)
                if (file.type === "text/csv") {
                    parseCSV(file, handleFileUpload);
                } else if (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    parseXLSX(file, handleFileUpload);
                }
            });
        },
        onDropRejected: (rejectedFiles) => {                
                showToast(
                    "error",
                    "Please upload valid file"
                );                }        
    });
    const sendInvite = async (userdata) => {
        let params = {
            organisation_id: organisationIdOfUser,
            trigger: "inviteCustomer",
            link: `${link}/${dashboardConfig?.invite_customer}`,
            hours: organisationInfo?.setting?.link_expiry_duration_in_hours,
            userdata
        };
        let resp = await handleEmailBulkNotification(params);
        if (resp[0]?.status == "success") {
            dispatch(setcsvBulkresponse(true))
        }
    };
    let enumArray = [];
    const acceptedFile = acceptedFiles.map((file) => {
        let fileData = {
            file: file,
            file_path: file.path,
            file_size: file.size,
        };
        return fileData;
    });
    const getEnum = () => {
        if (Array.isArray(enums)) {
            enumArray = enums;
        } else {
            enumArray = Object.keys(enums).map((key) => {
                return key.split("/")[1];
            });
        }
        return enumArray;
    };
    const handleFileUpload = async (result) => {
       if(!result?.length){
        showToast(
            "error",
            "The uploaded CSV file is empty"
        ); 
        setUploading(false)
        return;               
       }
        setUploadedFile(result);
        if (!add_customer && !bulk_upload) {
            inviteBulkCustomer(result);
        } else if(add_customer) {
            addBulkCustomer(result);
        }else if(bulk_upload){
            validate(result)
        }
    };

    function showToast(type, message) {
        setMessageToast({ type: type, msg: message });
        setTimeout(() => {
            setMessageToast(null);
        }, 2000);
    }

    const parseCSV = (file, callback) => {
        Papa.parse(file, {
            header: true,
            dynamicTyping: true,
            complete: (result) => {
                const modifiedData = result.data
                    .map((row) => {
                        const cleanedRow = removeNullProperties(row);
                        const stringifiedRow = Object.fromEntries(
                            Object.entries(cleanedRow).map(([key, value]) => [key, String(value)])
                        );
                        return stringifiedRow;
                    })
                    .filter((row) => Object.keys(row).length > 0);
                callback(modifiedData);
            },
            error: (error) => {
                console.error("Error parsing CSV:", error);
            },
        });
    };

    const parseXLSX = (file, callback) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            // Convert the JSON data to a usable format (similar to how CSV is parsed)
            const headers = jsonData[0];
            const rows = jsonData.slice(1).map((row) =>
                headers.reduce((acc, header, index) => {
                    // acc[header] = row[index];
                    acc[header] = row[index] !== undefined ? String(row[index]) : "";
                    return acc;
                }, {})
            );
            const cleanedData = rows.map(removeNullProperties).filter((row) => Object.keys(row).length > 0);
            callback(cleanedData);
        };
        reader.readAsArrayBuffer(file);
    };

    const removeNullProperties = (obj) => {
        const newObj = { ...obj };
        for (const prop in newObj) {
            if (newObj[prop] === null || newObj[prop] === undefined || newObj[prop] === "") {
                delete newObj[prop];
            }
        }
        return newObj;
    };

    const convertKeysToLowercase = (obj) => {
        const newObj = {};
        for (const key in obj) {
            newObj[key?.toLowerCase()] = obj[key];
        }
        return newObj;
    };

    const inviteBulkCustomer = async (result) => {
        const userdata = result
                .filter(user => user.Name !== null && user.Email !== null)
                .map(user => convertKeysToLowercase(removeNullProperties(user)));
            let isValid = true;
            userdata.forEach((user) => {
                const nameValid =
                    user.name?.trim().length >= (validators?.name?.min_length || 0);
                const emailValid = regex_pattern?.test(user.email);

                if (!nameValid && !emailValid) {
                    showToast(`Invalid name and email for user: ${user.name}`);
                    isValid = false;
                } else if (!nameValid) {
                    showToast(
                        "error",
                        error_messages?.min_error
                            ? `${error_messages?.min_error}`
                            : `Invalid Length. Enter Minimum ${validators.min_error || 0} letter Name in CSV file`
                    );
                    isValid = false;
                } else if (!emailValid) {
                    showToast(
                        "error",
                        error_messages?.pattern_error
                            ? `${error_messages?.pattern_error} in ${user.email}`
                            : `Pattern mismatch ${validators.pattern_error}`
                    );
                    isValid = false;
                }
            });
            if (isValid) {
                sendInvite(userdata);
            } else {
                setUploadedFile(null);
                showToast(
                    "error",
                  "Invalid File Check the all the fields in the file"
                );
            }
        // console.log("🚀 ~ inviteBulkCustomer ~ userdata:", userdata)
        // Your existing inviteBulkCustomer logic here
    };

    const addBulkCustomer = async (result) => {
        const userdata = result.map(user => removeNullProperties(user));
            let wf_id = dashboardConfig?.parent_wf_id
            
            let response = await dispatch(
                ValidateCsvData({ userdata, wf_id })
            ).unwrap();
            if (response?.status?.toLowerCase() == 'success') {
                dispatch(setSelectedData({ key: name, value: acceptedFile }));
                let userInfo = response.data
                dispatch(setbulkaddCustomer(userInfo))
            } else if (response?.status?.toLowerCase() == 'failed') {
                setUploadedFile(null)
                seterrModal(true)
                const ErrorFields = response?.data?.flatMap(item => {
                    return item.error_columns.map(column => {
                        return `${column.label}: ${column.error_message}`;
                    });
                });
                // Set unique error fields
                setUniqueErrorFields([...new Set(ErrorFields)]);
            } else {
                setUploadedFile(null)
                showToast("error", response?.message);
            }
    };

    const validate = async (result) => {
        try {
            const validationErrors = await validateUserData(result, workflowConfig?.form_fields,user_hierarchy);
            dispatch(setbulkaddWorkflow(validationErrors))
            } catch (error) {
            console.error("Error during validation:", error);
        }
    };

   async function mapUsers(users , idToLabelMap) {
        return users?.map(user => {
            const mappedUser = {};
            for (const [id, value] of Object.entries(user)) {
                if (idToLabelMap[id]) {
                    mappedUser[idToLabelMap[id]] = value;  // Map `id` to `label`
                } else {
                    mappedUser[id] = value;  // For fields that don't need mapping
                }
            }
            return mappedUser;
        }) || [];
    }

    async function validateUserData(userData, formFields, user_hierarchy) {
        const invalidUsers = [];
        const validUsers = [];

        // Mapping for field ids to labels for easier conversion
        const idToLabelMap = formFields.reduce((map, field) => {
            map[field.id] = field.label;
            return map;
        }, {});

        // Validate the user data
        for (const user of userData) {
            const userWithErrors = {}; 
            let isValid = true; 
    
            for (const field of formFields || []) {
                const value = user[field.label] || user[field.id];
                userWithErrors[field.label] = value;
    
                // Required validation
                if (field.validators.required && (!value || value === "")) {
                    userWithErrors[field.label] = field.error_messages.required_error;
                    isValid = false; 
                    continue;
                }
    
                // If value is present, perform other validations
                if (value) {
                    isValid = await validateField(field, value, userWithErrors,user) && isValid;
                }
            }
            if (!isValid) {
                invalidUsers.push(userWithErrors);
            } else {
                const mappedUser = {};
                formFields?.forEach(field => {
                    mappedUser[field.id] = user[field.label] || user[field.id];
                });
                validUsers.push(mappedUser);
            }
    
        }
        let res = null;
        if(user_hierarchy){
            let params = {
             bulkUploadData : validUsers,
             organisationId : organisationIdOfUser,
             workflowConfigId:workflowConfig?.dynamic_configuration_id
            }
             res = await dispatch(createUserHierarchy(params)).unwrap()
             dispatch(updateDropdownOptions(params))
           }else{
           handleNext(validUsers)
           }
        const inactiveUsers = res ? res.data?.inActiveUsers : [];
        const dataMismatchUsers = res ? res.data?.dataMismatch : []; 
        const tmMismatch = res ? res.data?.tmExists : []; 
        const CountvalidUsers = validUsers?.length - (inactiveUsers?.length + dataMismatchUsers?.length + tmMismatch?.length);
        const mappedInactiveUsers = await mapUsers(inactiveUsers ,idToLabelMap)
        const mappedDataMismatchUsers = await mapUsers(dataMismatchUsers ,idToLabelMap)
        const mappedtmExists = await mapUsers(tmMismatch ,idToLabelMap)

        // Combine invalid users and mapped inactive users
        const combinedUsers = [
            ...invalidUsers,
            ...mappedInactiveUsers,
            ...mappedDataMismatchUsers,
            ...mappedtmExists
        ];
           setUploading(false)
        return {
            totalInvalidRecords: combinedUsers.length,
            totalValidRecords: CountvalidUsers,
            invalidRecords: combinedUsers
        };
    }

    async function validateField(field, value, userWithErrors,user) {
        // Pattern validation
        if (field.validators.pattern) {
            const pattern = new RegExp(field.validators.pattern[0]);
            if (!pattern.test(value)) {
                userWithErrors[field.label] = field.error_messages.pattern_error;
                return false;
            }
        }
    
        // Min length validation
        if (field.validators.min_length && value.length < field.validators.min_length) {
            userWithErrors[field.label] = field.error_messages.min_error.replace('<x>', field.validators.min_length);
            return false;
        }
    
        // Max length validation
        if (field.validators.max_length && value.length > field.validators.max_length) {
            userWithErrors[field.label] = field.error_messages.max_error;
            return false;
        }
    
        // Mobile number validation
        if (field.id.includes('mobile')) {
            const mobile = "+" + value;
            const mobileArr = mobile.split("-");
            const mobileValidation = matchDetails("calling_code", mobileArr[0], staticData.countryData);
            
            if (mobileValidation) {
                if (mobileValidation.minLen && mobileArr[1].length < mobileValidation.minLen) {
                    userWithErrors[field.label] = `${field.label} should be a minimum of ${mobileValidation.minLen} characters`;
                    return false;
                }
                if (mobileValidation.maxLen && mobileArr[1].length > mobileValidation.maxLen) {
                    userWithErrors[field.label] = `${field.label} should be a maximum of ${mobileValidation.maxLen} characters`;
                    return false;
                }
                user[field.label] = mobile; // Update the user object with the validated mobile number
            }
        }
    
        // Date of Birth validation
        if (field.id.includes('birth_date')) {
            const res = validateDate(value);
            if (!res.isValid) {
                userWithErrors[field.label] = res.errorMessage;
                return false;
            }
        }
    
        return true; 
    }

    const handleNext = async (validUsers) => { try {
          const payloadArray = validUsers;
          const finalPayloadArray = [];
          for (let record of payloadArray) {
            let order = 1;
            let sourceDataFields = workflowConfig?.sourceData_fields;
            const deletedFields = {};
            if (Array.isArray(sourceDataFields)) {
              for (const fieldObj of sourceDataFields) {
                const fieldName = fieldObj?.id;
                if (
                  record &&
                  typeof record === "object" &&
                  record.hasOwnProperty(fieldName)
                ) {
                  deletedFields[fieldName] = record[fieldName];
                  record = Object.fromEntries(
                    Object.entries(record).filter(([key]) => key !== fieldName)
                  );
                }
              }
            }
            const isEmailVerified = true;
            const isMobileVerified = true;
            let saveData = [];
            const subworkFields = workflowConfig.subwork_fields || [];
            const filteredData = subworkFields.reduce((acc, field) => {
              const fieldName = field.id;
              if (record.hasOwnProperty(fieldName)) {
                acc[fieldName] = record[fieldName];
              }
              return acc;
            }, {});

            saveData.push(filteredData);
            let formattedData={}
            Object.keys(record).forEach(key => {
                if (!subworkFields.some(field => field.id === key)) {
                    formattedData[key] = record[key];
                }
            });
            
            let applicant_sequence = workflowConfig?.application_sequence;
            const dynamicConfigId = workflowConfig?.dynamic_configuration_id;
            const configurationId = workflowConfig?.dynamic_configuration_id;
            let uniqueName = workflowConfig?.application_sequence
              ? workflowConfig?.application_sequence
              : workflowConfig?.wf_name;
            let application_ref_id = uniqueWorkFlowId(uniqueName);
            let recursiveData = {};
            let finalPayload = createMasterDataPayload(
              null,
              deletedFields,
              workflowConfig?.organisation_id,
              configurationId,
              saveData,
              isEmailVerified,
              isMobileVerified,
              null,
              null,
              null,
              order,
              dynamicConfigId,
              application_ref_id,
              loggedUserId,
              applicant_sequence,
              loggedInUserName,
              loggedInUserEmail,
              loggedInUserMobileNumber,
              recursiveData,
              null,
              null,
              null,
              formattedData,
              null
            );
            if (!sourceDataFields) {
              finalPayload.source_data.max_active_group = 2;
              finalPayload.source_data.max_active_section = 1;
              finalPayload.source_data.active_section = 1;
              finalPayload.source_data.active_group = 2;
              finalPayload.source_data[workflowConfig?.array_name] = saveData;
            }
            finalPayload.verification = true;
            finalPayload.active_step_to_update=workflowConfig?.active_step_to_update
            finalPayload.active_status_to_update=workflowConfig?.active_status_to_update
            finalPayloadArray.push(finalPayload);
          }
          dispatch(createBulkPrimaryWorkFlows(finalPayloadArray));
        } catch (error) {
          console.error("Error processing bulk workflow creation:", error);
        }
      };

    const removeFile = () => {
        dispatch(clearSelectedData());
        dispatch(clearbulkaddCustomer());
        setUploadedFile(null);
    };

    useEffect(() => {
        const uploadedFile = acceptedFile?.[0];
        if (uploadedFile) {
            const { path } = uploadedFile;
            const { file_path, file_size } = uploadedFile;
            let sizeInMB = file_size !== null ? (file_size / (1024 * 1024)).toFixed(2) : "";
            // console.log("🚀 ~ useEffect ~ sizeInMB:", sizeInMB)

            setFileSize(sizeInMB);
            setFileName(file_path);
        }
    }, [acceptedFile]);

    return (
        <>
            {messageToast?.msg && <Toast message={messageToast?.msg} type={messageToast?.type} />}
            <Label image={true} htmlFor="upload" label={label} tooltip={tooltip} validators={validators} className={`${label_style} `} />
            <div className={size}>
                {uploadedFile && !uploading ? (
                    <div className={`file-uploaded`}>
                        <div className="upload-container ps-1">
                            <Image imageSrc={ImageUploaded} className="m-0" />
                            <div className="upload-rightContainer">
                                <div className="upload-content">
                                    <div className="d-flex flex-column d-md-block">
                                        <p className="mb-0 fs-12px break-work-when-exceeds">{fileName}</p>
                                            <span className="fs-10px">
                                                {fileSize && `${fileSize}MB`}
                                            </span>
                                        
                                    </div>
                                    <button
                                        className={`remove_button ${isDisabLed ? true : isEditable !== undefined ? !isEditable && "radioDisabled" : ""}`}
                                        disabled={
                                            remove_disabled
                                                ? false
                                                : selectedData && is_disabled && is_disabled !== undefined && eval(is_disabled)
                                                    ? true
                                                    : isDisabLed
                                                        ? false
                                                        : isEditable !== undefined
                                                            ? !isEditable
                                                            : false
                                        }
                                        onClick={removeFile}
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div
                        className={`${isDisabLed ? true : !isEditable && "radioDisabled"} ${!error ? "file-uploader" : "error"} ${custom_styles} px-3 px-md-0 pe-none`}
                    >
                        <Image className="ms-2" imageSrc={ImageUpload} alt="" />
                        <div {...getRootProps({ className: "dropzone" })}>
                            <input {...getInputProps({ className: "dropzone" })} />
                            {uploading ? 
                           <p> Document validation in progress...
                       </p> :
                            <p>
                                Drag and drop or <span className="pe-auto">browse</span> from system upto {maxSizeInMb}MB | {getEnum().join(", ")}
                            </p> 
}
                        </div>
                    </div>
                )}
                <>
                    <Modal
                        backdrop="static"
                        onHide={handleClose}
                        centered
                        scrollable
                        show={errModal}>
                        <Modal.Body className="px-4">
                            <div className="align-items-center d-flex flex-column justify-content-center">
                                <span className="align-items-center d-flex flex-column justify-content-center">

                                    <svg className="mb-3" xmlns="http://www.w3.org/2000/svg" width="51.846" height="48.126" viewBox="0 0 51.846 48.126">
                                        <g id="Group_45974" data-name="Group 45974" transform="translate(-682.099 -219.369)">
                                            <g id="noun-exclamation-2077915" transform="translate(682.099 219.369)">
                                                <g id="Group_45818" data-name="Group 45818" transform="translate(0 0)">
                                                    <path id="Path_54228" data-name="Path 54228" d="M64.128,89.124c-.275-.5-.551-1-.826-1.5l-1.418-2.588c-.634-1.153-1.263-2.3-1.9-3.455q-1.115-2.034-2.234-4.074l-2.432-4.427q-1.263-2.291-2.52-4.588-1.224-2.229-2.452-4.463l-2.09-3.808-.186-.338c-.649-1.185-1.3-2.364-1.948-3.549-.5-.914-1-1.829-1.507-2.743-.307-.561-.613-1.122-.925-1.683a6.36,6.36,0,0,0-1.263-1.73,5.112,5.112,0,0,0-6.666-.156,5.839,5.839,0,0,0-1.429,1.845c-.3.546-.6,1.091-.9,1.637-.494.9-.992,1.8-1.486,2.707-.644,1.174-1.289,2.343-1.933,3.518q-1.13,2.065-2.265,4.125L25.3,68.3q-1.263,2.291-2.52,4.588-1.216,2.221-2.437,4.437-1.122,2.05-2.25,4.094-.943,1.746-1.9,3.486c-.478.873-.961,1.751-1.439,2.624-.286.52-.566,1.034-.852,1.554a5.72,5.72,0,0,0-.821,2.873,5.244,5.244,0,0,0,1.392,3.424,5.107,5.107,0,0,0,3.434,1.59c.348.021.7.005,1.05.005H59.873a5.1,5.1,0,0,0,5.04-4.77A5.39,5.39,0,0,0,64.128,89.124Z" transform="translate(-13.083 -48.859)" fill="#ff5757" />
                                                    <path id="Icon_awesome-exclamation" data-name="Icon awesome-exclamation" d="M7.786,17.985a3.331,3.331,0,1,1-3.331-3.331A3.334,3.334,0,0,1,7.786,17.985ZM1.511,1.049l.566,11.324a1,1,0,0,0,1,.949H5.836a1,1,0,0,0,1-.949L7.4,1.049A1,1,0,0,0,6.4,0H2.508A1,1,0,0,0,1.511,1.049Z" transform="translate(21.466 19.002)" fill="#fff" />
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    <p className="fs-17px fw-semibold text-theme">Error in uploading CSV!</p>
                                    <p className="fs-17px fw-semibold mb-4">Below are the fields with incorrect data. Kindly update it locally with the correct data and re-upload.</p>
                                    <p className="fs-17px fw-semibold mb-2 align-self-start">Names of the field</p>
                                    <div className="border border-2 w-100 p-3 fs-17px bg-theme-grey-1 max-h-125px overflow-y-scroll theme-scrollbar mb-4">
                                        {ErrorFields.map((item, index) => {
                                            return (
                                                <span className="fs-17px fw-semibold">{item}{index !== ErrorFields.length - 1 ? ", " : ""}<br></br></span>
                                            )
                                        })}
                                    </div>
                                    <div className=" form-button justify-content-end w-100">

                                        <Button className="primary_button" onClick={handleClose}>Re-upload</Button>
                                    </div>

                                </span>
                            </div>
                        </Modal.Body>
                    </Modal>
                </>
            </div>
        </>
    );
};

export default CsvUpload;
